import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Alert, Box, Link, Typography } from 'components/AORedesign';
import { handleFileDownload } from 'components/CommonUtilityServices/DownloadFileService';
import { handlePdfDownload } from 'components/CommonUtilityServices/DownloadPdfService';
import { redirectUrlFunction } from 'components/CommonUtilityServices/RedirectService';
import { ROUTE_REDESIGN_RESOURCES_STORM } from 'constants/routes';
import LinksContainer from './LinksContainer';

const PDF_ICON = 'pdf';
const DOCUMENT_ICON = 'document';
const OPEN_IN_NEW_TAB_ICON = 'openInNew';
const PL_COSTIMATOR_REQUEST_BODY = { Area: 'Personal Lines', DetailedContext: [], TypeOfRedirect: 'Costimator' };
const BONDS_REDIRECT_REQUEST_BODY = { Area: 'Policy Services Menu', DetailedContext: [], TypeOfRedirect: 'Surety and Fidelity Bonds' };

const AdditionalInformation = () => {
  const [isDownloadingPdfErrorVisible, setIsDownloadingPdfErrorVisible] = useState(false);
  const [downloadingPdfError, setDownloadingPdfError] = useState('');

  const history = useHistory();

  const handleClickDownloadFile = (event) => {
    setIsDownloadingPdfErrorVisible(false);
    const pdfUrl = event.currentTarget.getAttribute('data-pdf');
    if (pdfUrl) {
      handlePdfDownload('GET', null, pdfUrl, () => {}, setDownloadingPdfError, setIsDownloadingPdfErrorVisible, 'newWindow');
    } else {
      const _fileUrl = event.currentTarget.getAttribute('data-file');
      handleFileDownload(_fileUrl, () => {}, setDownloadingPdfError, setIsDownloadingPdfErrorVisible);
    }
  };

  const resetErrorVisibility = () => {
    setIsDownloadingPdfErrorVisible(false);
  };

  const handleGoToRoute = (e) => {
    setIsDownloadingPdfErrorVisible(false);
    const route = e.currentTarget.getAttribute('data-route');
    history.push(route);
  };

  const handleRedirectUrl = (requestBody) => {
    setIsDownloadingPdfErrorVisible(false);
    redirectUrlFunction(
      requestBody,
      'POST',
      null,
      () => {},
      () => {},
    );
  };

  return (
    <Box mb={2}>
      <Box mt={1} mb={4}>
        <Typography variant="h6">Additional Information</Typography>
      </Box>
      {isDownloadingPdfErrorVisible && (
        <Box mb={2}>
          <Alert color="error" alertTitleMessage={downloadingPdfError} />
        </Box>
      )}
      <Box>
        <LinksContainer heading="personal lines">
          <Link onClick={() => handleRedirectUrl(PL_COSTIMATOR_REQUEST_BODY)} endIcon={OPEN_IN_NEW_TAB_ICON}>
            PL Costimator
          </Link>
        </LinksContainer>
        <LinksContainer heading="Flood Insurance">
          <Link href="https://brandfolder.com/s/jv6673qvn5crqzvtrvqjg54v" endIcon={PDF_ICON}>
            Flood Agency Enrollment Form
          </Link>
          <Link href="https://ngm.agent.odysseynext.com/login" endIcon={OPEN_IN_NEW_TAB_ICON}>
            Flood Policy Processing System
          </Link>
          <Link href="https://brandfolder.com/s/v9cmx7qsbs74kwmmmk85q4s" endIcon={PDF_ICON}>
            National Flood Services (NFS) Resources and Contacts
          </Link>
        </LinksContainer>
        <LinksContainer heading="Receiving lexisnexis Data">
          <Link data-pdf={'/resources/Lexis_Nexis_Application.pdf'} onClick={handleClickDownloadFile} endIcon={PDF_ICON}>
            LexisNexis Application
          </Link>
          <Link data-file={'/resources/Lexis_Nexis_Node_Requirements.doc'} onClick={handleClickDownloadFile} endIcon={DOCUMENT_ICON}>
            LexisNexis Node Requirements
          </Link>
          <Link data-file={'/resources/LexisNexis_Contact_Information.doc'} onClick={handleClickDownloadFile} endIcon={DOCUMENT_ICON}>
            LexisNexis Contact Information
          </Link>
        </LinksContainer>
        <LinksContainer heading="additional products">
          <Link data-route={ROUTE_REDESIGN_RESOURCES_STORM} onClick={handleGoToRoute}>
            Storm Resources
          </Link>
          <Link onClick={() => handleRedirectUrl(BONDS_REDIRECT_REQUEST_BODY)} endIcon={OPEN_IN_NEW_TAB_ICON}>
            Bonds
          </Link>
        </LinksContainer>
        <LinksContainer heading="industry standards">
          <Link onClick={resetErrorVisibility} href={'https://www.independentagent.com/act/pages/default.aspx'} endIcon={OPEN_IN_NEW_TAB_ICON}>
            Agents Council For Technology (ACT)
          </Link>
          <Link onClick={resetErrorVisibility} href={'https://www.augiegroup.org/'} endIcon={OPEN_IN_NEW_TAB_ICON}>
            ACORD Info Exchange
          </Link>
        </LinksContainer>
      </Box>
    </Box>
  );
};

export default AdditionalInformation;
